<template>
  <div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
            show-expand
            :single-expand="true"
            :expanded.sync="expanded"
            :item-class="getRowColor"
          >
            <template v-slot:item.data="{ item }">
              {{ getDataItem(item) }}
            </template>

            <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th
                        v-for="header in getHeadersExpanded(item)"
                        :key="header.value"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td
                        v-for="header in getHeadersExpanded(item)"
                        :key="header.value"
                      >
                        {{ getValorExpanded(item, header.value) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'Configuração',
          align: 'start',
          filterable: true,
          value: 'descricao',
        },
        {
          text: 'Data',
          align: 'start',
          filterable: true,
          value: 'data',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        let dados = {}

        if (item.dados) {
          try {
            dados =
              typeof item.dados === 'string'
                ? JSON.parse(item.dados)
                : item.dados
          } catch (e) {
            dados = {}
          }
        }

        return {
          ...item,
          id: item.id || index,
          dados,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a data correta da linha.
     *
     * @param {Object} item
     * @returns {String}
     */
    getDataItem(item) {
      const data = item.id === 4 || item.id === 5 ? item.updated_at : item.data

      return data ? this.formatDate(data) : ''
    },

    /**
     * Retorna as colunas dinâmicas do expanded conforme o tipo da configuração.
     *
     * @param {Object} item
     * @returns {Array}
     */
    getHeadersExpanded(item) {
      const headersPorId = {
        5: [{ text: 'Versão', value: 'ds_texto' }],
        4: [{ text: 'Versão', value: 'ds_texto' }],
        3: [
          { text: 'Data e hora da importação', value: 'dt_relatorio' },
          { text: 'Quantidade de dias', value: 'dias_impor_xml' },
        ],
        2: [
          { text: 'Vigência', value: 'ds_vigencia' },
          { text: 'Status', value: 'st_importacao' },
          { text: 'Data da importação', value: 'dt_importacao_fim' },
        ],
        1: [
          { text: 'Data da inclusão', value: 'dt_inclusao' },
          { text: 'Data de habilitação', value: 'dt_habilitacao' },
          { text: 'Data de validade', value: 'dt_validade_certificado' },
          {
            text: 'Dias para expirar o certificado',
            value: 'dias_expirar_certificado',
          },
        ],
      }

      return headersPorId[item.id] || []
    },

    /**
     * Retorna o valor formatado de uma coluna do expanded.
     *
     * @param {Object} item
     * @param {String} key
     * @returns {String|Number}
     */
    getValorExpanded(item, key) {
      const dados = item.dados || {}
      const value = dados[key]

      if (!value) return '-'

      const camposData = [
        'dt_relatorio',
        'dt_importacao_fim',
        'dt_inclusao',
        'dt_habilitacao',
        'dt_validade_certificado',
      ]

      if (camposData.includes(key)) {
        const data = new Date(value)

        const dia = String(data.getDate()).padStart(2, '0')
        const mes = String(data.getMonth() + 1).padStart(2, '0')
        const ano = data.getFullYear()

        const hora = String(data.getHours()).padStart(2, '0')
        const minuto = String(data.getMinutes()).padStart(2, '0')

        return `${dia}/${mes}/${ano} - ${hora}:${minuto}`
      }

      return value
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      if (item.em_dia == 0) {
        return 'table-row-color-red'
      }

      return 'table-row-color-green'
    },
  },
}
</script>

<style lang="scss" scoped>
#profissionais-lotacoes {
  .st-lotacao-inativa {
    background: #d4d4db;
    border-radius: 20px;
    padding: 5px 10px;
    font-weight: 700;
    font-size: 11px;
  }
}
</style>
